import { usePrefectureDashboardData } from '@/hooks/usePrefectureDashboardData'

const InterPrefectureAnalysis = () => {
  const { data, isLoading, error } = usePrefectureDashboardData()

  if (isLoading) {
    return <div className="bg-white p-6 rounded-lg shadow animate-pulse">読み込み中...</div>
  }

  if (error || !data) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { interPrefectureAnalysis } = data

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">都道府県間対戦分析</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="font-semibold mb-3">勝率順</h3>
          <div className="space-y-2">
            {interPrefectureAnalysis.opponentsByWinRate.slice(0, 10).map((item, index) => (
              <div key={index} className="flex justify-between text-sm">
                <span>{item.opponentPrefectureName}</span>
                <span className="font-medium">{item.winRate.toFixed(1)}%</span>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-semibold mb-3">対戦数順</h3>
          <div className="space-y-2">
            {interPrefectureAnalysis.opponentsByMatchCount.slice(0, 10).map((item, index) => (
              <div key={index} className="flex justify-between text-sm">
                <span>{item.opponentPrefectureName}</span>
                <span className="font-medium">{item.totalMatches}試合</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InterPrefectureAnalysis

